import React, { useContext, useEffect, useState } from 'react';
import { getDoc, setDoc, doc } from 'firebase/firestore';
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { db } from '../firebase'; // Adjust the import based on your Firebase setup
import { TextField, Button, Card, CardContent, CardMedia, Typography, CircularProgress,Box,Snackbar,Alert,IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AppContext from '../AppContext';

const ShopComponent = () => {
  const { shopId, t } = useContext(AppContext);
  const [shopData, setShopData] = useState({
    shopLogo: '',
    shopName: '',
    shopAddress: '',
    phoneNumber: '',
  });
  const [uploading, setUploading] = useState(false);
  const [loading,setLoading]=useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success'
  });

  useEffect(() => {
    if (shopId) {
      setLoading(true);
      try{
        fetchShopData(shopId);
      }
      catch(error)
      {
        console.log(error);
      }
      finally{
        setLoading(false);
      }
      
    }
  }, [shopId]);

  const fetchShopData = async (id) => {
    const docRef = doc(db, 'shops', id);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      setShopData(docSnap.data());
    } else {
      console.log('No such document!');
    }
  };

  const handleChange = (e) => {
    setShopData({
      ...shopData,
      [e.target.name]: e.target.value,
    });
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const storage = getStorage();
      const storageRef = ref(storage, `shopLogos/${shopId}`);
      setUploading(true);
      try {
        await uploadBytes(storageRef, file);
        const downloadURL = await getDownloadURL(storageRef);
        setShopData((prevData) => ({
          ...prevData,
          shopLogo: downloadURL,
        }));
       // alert('Logo uploaded successfully');
      } catch (error) {
        //console.error('Error uploading file:', error);
        showSnackbar('Error uploading file', 'error');
      } finally {
        setUploading(false);
      }
    }
  };

  const handleSave = async () => {
    const id = shopId; // Generate a new shopId if not provided
    await setDoc(doc(db, 'shops', id), shopData,{merge:true});
   // alert('Shop information saved successfully');
    showSnackbar('Shop information saved successfully', 'success');
  };

  const showSnackbar = (message, severity) => {
    setSnackbar({ open: true, message, severity });
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar({ ...snackbar, open: false });
  };

  return (
    <Card variant='outlined'>
       {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '300px' }}>
          <CircularProgress />
        </Box>
        ) :(
      <CardContent>
        <Typography variant="body1">{t("Logo")}</Typography>
       
        {shopData.shopLogo && (
          <Box sx={{ position: 'relative', display: 'inline-block' }}>
          <CardMedia
            component="img"
            height="200"
            width="200"
            image={shopData.shopLogo}
            alt={shopData.shopName}
          />
           <IconButton
        sx={{ position: 'absolute', top: 0, right: 0 }}
        onClick={() => setShopData({ ...shopData, shopLogo: '' })}
      >
        <DeleteIcon />
        </IconButton>
          </Box>
        )}
        <input
          type="file"
          accept="image/*"
          onChange={handleFileChange}
          disabled={uploading}
        />
      
        {uploading && <CircularProgress />}
        <TextField
          label={t("Shop Name")}
          name="shopName"
          value={shopData.shopName}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />
        <TextField
          label={t("Shop Address")}
          name="shopAddress"
          value={shopData.shopAddress}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />
        <TextField
          label={t("Phone Number")}
          name="phoneNumber"
          value={shopData.phoneNumber}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />
        <Button variant="contained" disableElevation color="primary" onClick={handleSave} disabled={uploading}>
          {t("Save")}
        </Button>
      </CardContent>
        )}
         <Snackbar 
        open={snackbar.open} 
        autoHideDuration={6000} 
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Card>
  );
};

export default ShopComponent;
